import { Text, View } from "@react-pdf/renderer";
import { calculateClearPatientFee } from "helpers/fee";
import { centsToDollars, parsePrice } from "helpers/price";
import { useMemo } from "react";
import { IUniqueProceduresByProvider } from "types/Order/Order";

import { styles } from "../styles";

export type Props = {
  proceduresByProviders: IUniqueProceduresByProvider[];
  clearPatientFeeValueInPercentage?: number | null;
};

export function ProcedureBreakdown({
  proceduresByProviders,
  clearPatientFeeValueInPercentage,
}: Props) {
  const subtotal = useMemo(() => {
    return proceduresByProviders.reduce(
      (acc: any, proceduresByProvider: any) => {
        return acc + proceduresByProvider.subtotal;
      },
      0
    );
  }, [proceduresByProviders]);

  return (
    <View style={{ display: "flex", flexDirection: "column" }}>
      <View
        style={{
          marginLeft: 50,
          marginRight: 50,
          marginBottom: 20,
          marginTop: 10,
        }}
      >
        <View
          style={{
            display: "flex",
            width: "100%",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          {proceduresByProviders.map((proceduresByProvider, index) => (
            <View style={styles.table}>
              <View
                style={[styles.row, styles.headerRow, styles.blueBackground]}
              >
                <Text style={(styles.cell, styles.tableTitle)}>
                  {proceduresByProvider.providerName}
                </Text>
              </View>
              {proceduresByProvider.procedures.map((procedure, index) => (
                <View style={[styles.row]} key={`${procedure.code}-${index}`}>
                  <Text style={[styles.cell, styles.leftCell]}>
                    {procedure.cptDescription}
                  </Text>
                  <Text
                    style={[
                      styles.cell,
                      styles.rightCell,
                      styles.rightCellBorder,
                    ]}
                  >
                    {parsePrice(centsToDollars(procedure.totalAmountInCents))}
                  </Text>
                </View>
              ))}
              <View
                style={{
                  ...styles.row,
                  ...styles.greyBackground,
                  fontSize: 12,
                  fontFamily: "Helvetica-Bold",
                  fontWeight: 900,
                  marginBottom: 10,
                }}
              >
                <Text style={[styles.cell, styles.leftCell]}>Subtotal</Text>
                <Text
                  style={[
                    styles.cell,
                    styles.rightCell,
                    styles.rightCellBorder,
                  ]}
                >
                  {parsePrice(centsToDollars(proceduresByProvider.subtotal))}
                </Text>
              </View>
            </View>
          ))}
          <View
            style={{
              ...styles.row,
              ...(clearPatientFeeValueInPercentage
                ? styles.greyBackground
                : styles.blueBackground),
              fontSize: 12,
              fontFamily: "Helvetica-Bold",
              fontWeight: 900,
              marginTop: 5,
            }}
          >
            <Text style={[styles.cell, styles.leftCell, styles.blueBackground]}>
              Total Cosmetic Surgery Cost
            </Text>
            <Text
              style={[
                styles.cell,
                styles.rightCell,
                styles.rightCellBorder,
                styles.blueBackground,
              ]}
            >
              {parsePrice(centsToDollars(subtotal))}
            </Text>
          </View>
        </View>
      </View>
      {clearPatientFeeValueInPercentage && (
        <View
          style={{
            width: "100%",
          }}
        >
          <Text>
            A{" "}
            <Text style={{ fontFamily: "Helvetica-Bold" }}>
              {parsePrice(
                calculateClearPatientFee(
                  centsToDollars(subtotal),
                  clearPatientFeeValueInPercentage
                )
              )}{" "}
            </Text>
            convenience and service fee will be added when paying by
            Credit/Debit card or Cherry financing.
          </Text>
        </View>
      )}
    </View>
  );
}
